import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import adminApi, { apiError } from "@/lib/adminApi";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // Tolérant aux saisies mobiles : espaces parasites et majuscules automatiques
      const { data } = await adminApi.post("/auth/login", {
        email: email.trim().toLowerCase(),
        password: password.trim(),
      });
      localStorage.setItem("staff_token", data.token);
      localStorage.setItem("staff_user", JSON.stringify(data.user));
      navigate("/admin");
    } catch (err) {
      setError(apiError(err, "Identifiants invalides."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-noir flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" data-testid="admin-login-back" className="inline-flex items-center gap-2 text-white/40 hover:text-gold text-xs uppercase tracking-[0.2em] transition-colors">
          <ArrowLeft size={14} /> Retour au site
        </Link>
        <div className="mt-6 bg-noir-surface border border-noir-border p-8 md:p-10">
          <p className="font-display text-3xl tracking-wide">
            <span className="text-gold">3M</span> MATCH PRO
          </p>
          <h1 className="mt-2 font-display uppercase text-4xl tracking-wide text-white">Espace Staff</h1>
          <p className="mt-2 text-white/50 text-sm">Accès réservé à l'équipe 3M Match Pro.</p>

          <form onSubmit={onSubmit} data-testid="admin-login-form" className="mt-8 space-y-5">
            <div>
              <label className="block text-[11px] font-bold uppercase tracking-[0.2em] text-white/60 mb-2">Adresse email</label>
              <input
                data-testid="admin-input-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
                inputMode="email"
                className="w-full bg-[#050505] border border-white/10 text-white px-4 py-3.5 text-base focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-all"
              />
            </div>
            <div>
              <label className="block text-[11px] font-bold uppercase tracking-[0.2em] text-white/60 mb-2">Mot de passe</label>
              <input
                data-testid="admin-input-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                className="w-full bg-[#050505] border border-white/10 text-white px-4 py-3.5 text-base focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-all"
              />
            </div>
            {error && (
              <p data-testid="admin-login-error" className="text-sm text-rouge-hover flex items-center gap-2">
                <Lock size={14} /> {error}
              </p>
            )}
            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="w-full py-4 bg-rouge text-white text-sm font-bold uppercase tracking-[0.15em] rounded-full hover:bg-rouge-hover transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading && <Loader2 size={16} className="animate-spin" />}
              Se connecter
            </button>
            <button
              type="button"
              data-testid="admin-forgot-link"
              onClick={() => setShowForgot(!showForgot)}
              className="w-full text-center text-xs text-white/40 hover:text-gold transition-colors"
            >
              Mot de passe oublié ?
            </button>
            {showForgot && (
              <p data-testid="admin-forgot-info" className="text-xs text-white/45 text-center border border-white/10 p-3">
                Pour réinitialiser votre accès, contactez l'administrateur principal de 3M Match Pro.
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
